// Logging control flags

import { config } from "./config";

export enum LogLevel {
  ERROR = "ERROR",
  WARN = "WARN",
  INFO = "INFO",
  DEBUG = "DEBUG",
  TRACE = "TRACE",
}

class Logger {
  private static instance: Logger;

  private constructor() {}

  public static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }
    return Logger.instance;
  }

  private log(level: LogLevel, message: string, ...args: any[]): void {
    if (!config.ENABLE_LOGGING) return;

    const timestamp = new Date().toISOString();
    const logMessage = `[${timestamp}] [${level}] ${message}`;

    switch (level) {
      case LogLevel.ERROR:
        console.error(logMessage, ...args);
        break;
      case LogLevel.WARN:
        console.warn(logMessage, ...args);
        break;
      case LogLevel.INFO:
        console.log(logMessage, ...args);
        break;
      case LogLevel.DEBUG:
        if (config.DEBUG_LOGGING) {
          console.debug(logMessage, ...args);
        }
        break;
      case LogLevel.TRACE:
        if (config.TRACE_LOGGING) {
          console.trace(logMessage, ...args);
        }
        break;
    }
  }

  public error(message: string, ...args: any[]): void {
    this.log(LogLevel.ERROR, message, ...args);
  }

  public warn(message: string, ...args: any[]): void {
    this.log(LogLevel.WARN, message, ...args);
  }

  public info(message: string, ...args: any[]): void {
    this.log(LogLevel.INFO, message, ...args);
  }

  public debug(message: string, ...args: any[]): void {
    this.log(LogLevel.DEBUG, message, ...args);
  }

  public trace(message: string, ...args: any[]): void {
    this.log(LogLevel.TRACE, message, ...args);
  }
}

export const logger = Logger.getInstance();
